import {Subject} from "rxjs/Subject";
import {AlarmListChangeEvent} from "./alarmListChangedEvent";

export class AlarmListSubscriber {
    subject: Subject<AlarmListChangeEvent>;
}